import { ref, watch } from 'vue';
import { WidgetInstance } from 'friendly-challenge';
import { useFocusWithin } from '@vueuse/core';
import useLiferayLocale from '../../../composables/useLiferayLocale';
import { useDebug } from '../../../composables/useDebug';

export const useCaptcha = (formRef = null) => {
    const { log } = useDebug();

    const captchaRef = ref();
    const widgetRef = ref();
    const captchaSolution = ref(null);
    const captchaVerified = ref(false);

    const doneCallback = solution => {
        log('Captcha was solved. The form can be submitted.', solution);

        captchaSolution.value = solution;
        captchaVerified.value = true;
    };

    const errorCallback = err => {
        console.log('There was an error when trying to solve the Captcha.', err);

        captchaSolution.value = null;
        captchaVerified.value = false;
    };

    const verify = () => {
        widgetRef.value?.start();
    };
    const { focused } = useFocusWithin(formRef);
    watch(focused, focused => {
        if (focused && !captchaVerified.value) {
            verify();
        }
    });

    const reset = () => {
        captchaVerified.value = false;
        widgetRef.value?.reset();
    };

    const { languageKey } = useLiferayLocale();
    watch(captchaRef, () => {
        // reset the widget instance when the container changes
        if (widgetRef.value) {
            widgetRef.value.destroy();
            captchaSolution.value = null;
            captchaVerified.value = false;
        }

        if (captchaRef.value) {
            widgetRef.value = new WidgetInstance(captchaRef.value, {
                sitekey: window.ams?.captchaSiteKey || 'FCMORSG3OLNM3EBD',
                startMode: 'none',
                language: languageKey.value,
                skipStyleInjection: false,
                doneCallback,
                errorCallback,
            });
        }
    });

    return {
        captchaRef,
        captchaVerified,
        captchaSolution,
        verify,
        reset,
    };
};
